<template>
  <div
    :class="{ 'modal-overlay': true, active: modelValue }"
    @click.self="close"
  >
    <div class="register-modal" role="dialog" aria-modal="true">
      <div class="modal-top-bar"></div>

      <div class="modal-header">
        <button
          class="modal-close"
          type="button"
          aria-label="关闭"
          @click="close"
        >
          ✕
        </button>
        <div class="modal-header-logo">
          <div class="logo-emblem"><div class="logo-emblem-inner"></div></div>
          <span class="logo-text">石家庄文旅投建设集团有限公司</span>
        </div>
        <div class="modal-title">供应商入库申请</div>
      </div>

      <div class="modal-body">
        <div v-show="!success" class="register-form">
          <div class="notice-bar">
            <svg
              class="notice-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <div class="notice-text">
              <strong>温馨提示：</strong>该账号仅用于<strong>供应商入库</strong>申请，请使用真实信息入库申请，账号信息将作为资质审核依据。
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="supplier-username"
              >手机号<span class="required">*</span></label
            >
            <div class="form-input-wrapper">
              <input
                id="supplier-username"
                ref="usernameInput"
                v-model="form.username"
                type="tel"
                inputmode="numeric"
                autocomplete="tel"
                class="form-input"
                :class="{ error: !!errors.username }"
                placeholder="请输入手机号（11位）"
                maxlength="11"
                @input="onUsernameInput"
              />
              <span class="form-input-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </span>
            </div>
            <div class="field-error" :class="{ show: !!errors.username }">
              {{ errors.username }}
            </div>
          </div>

          <div class="form-group" v-if="false">
            <label class="form-label" for="supplier-password"
              >密码<span class="required">*</span></label
            >
            <div class="form-input-wrapper">
              <input
                id="supplier-password"
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                class="form-input"
                :class="{ error: !!errors.password }"
                placeholder="请输入密码（8位以上）"
                @input="onPasswordInput"
              />
              <span class="form-input-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </span>
              <button
                type="button"
                class="password-toggle"
                tabindex="-1"
                @click="showPassword = !showPassword"
              >
                <svg
                  v-if="showPassword"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"
                  />
                  <path
                    d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"
                  />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg
                  v-else
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
            <div class="strength-bar">
              <div class="strength-segment" :class="strengthSegmentClass(1)"></div>
              <div class="strength-segment" :class="strengthSegmentClass(2)"></div>
              <div class="strength-segment" :class="strengthSegmentClass(3)"></div>
              <div class="strength-segment" :class="strengthSegmentClass(4)"></div>
            </div>
            <div class="strength-label" :style="{ color: strengthColor }">
              {{ strengthLabel }}
            </div>
            <div class="field-error" :class="{ show: !!errors.password }">
              {{ errors.password }}
            </div>
          </div>

          <div class="form-group" v-if="false">
            <label class="form-label" for="supplier-confirm-password"
              >确认密码<span class="required">*</span></label
            >
            <div class="form-input-wrapper">
              <input
                id="supplier-confirm-password"
                v-model="form.confirmPassword"
                :type="showConfirmPassword ? 'text' : 'password'"
                class="form-input"
                :class="{ error: !!errors.confirmPassword }"
                placeholder="请再次输入密码"
                @input="clearError('confirmPassword')"
              />
              <span class="form-input-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                  />
                </svg>
              </span>
              <button
                type="button"
                class="password-toggle"
                tabindex="-1"
                @click="showConfirmPassword = !showConfirmPassword"
              >
                <svg
                  v-if="showConfirmPassword"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"
                  />
                  <path
                    d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"
                  />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </svg>
                <svg
                  v-else
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
            <div class="field-error" :class="{ show: !!errors.confirmPassword }">
              {{ errors.confirmPassword }}
            </div>
          </div>

          <div class="form-divider"></div>

          <div class="form-actions">
            <div class="form-actions__buttons">
              <button
                type="button"
                class="submit-btn"
                :class="{ loading }"
                :disabled="loading"
                @click="submit"
              >
                <div class="btn-inner">
                  <div class="spinner"></div>
                  <span class="btn-text">立即申请</span>
                </div>
              </button>
              <button
                type="button"
                class="submit-btn submit-btn--ghost"
                :disabled="loading"
                @click="goLogin"
              >
                <div class="btn-inner">
                  <span class="btn-text">去登录</span>
                </div>
              </button>
            </div>
            <div class="attachment-preview">
              <span class="attachment-label">操作指导：</span>
              <span class="attachment-link" @click="openVideoPreview">
                <svg class="video-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
                <span class="attachment-name">供应商入库-线上办理操作指导视频.mp4</span>
              </span>
            </div>
          </div>
        </div>

        <div class="success-state" :class="{ show: success }">
          <div class="success-icon-wrap">
            <svg
              class="success-checkmark"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <div class="success-title">入库申请成功</div>
          <div class="success-desc">
            您的供应商账号已创建成功！<br />
            请前往登录页面使用账号密码登录，<br />完善供应商入库资质信息。
          </div>
          <div class="success-actions">
            <button class="btn-login" type="button" @click="goLogin">
              <span>前往登录</span>
            </button>
            <button class="btn-close-modal" type="button" @click="close">
              关闭
            </button>
          </div>
        </div>
      </div>

      <!-- 文件预览弹窗 -->
      <div
        class="video-preview-overlay"
        v-if="videoPreviewVisible"
        @click="closeVideoPreview"
      >
        <div class="video-preview-dialog" @click.stop>
          <div class="video-preview-header">
            <div class="video-preview-title">{{ currentVideoName }}</div>
            <button class="video-preview-close" @click="closeVideoPreview">×</button>
          </div>
          <div class="video-preview-body">
            <video
              :src="currentVideoUrl"
              controls
              preload="metadata"
              @error="handleVideoError"
              @loadstart="handleVideoLoadStart"
              @loadedmetadata="handleVideoLoadedMetadata"
            >
              您的浏览器不支持视频播放。
            </video>
          </div>
          <div class="video-preview-footer">
            <button class="video-preview-download" @click="downloadVideo">
              下载视频
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { registerSupplier } from "../api/common";

export default {
  name: "SupplierRegisterModal",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      success: false,
      showPassword: false,
      showConfirmPassword: false,
      strengthScore: 0,
      form: {
        username: "",
        password: "",
        confirmPassword: "",
      },
      errors: {
        username: "",
        password: "",
        confirmPassword: "",
      },
      // 视频预览相关
      videoPreviewVisible: false,
      currentVideoUrl: "https://www.sjzwltjsjt.com/files/供应商入库-线上办理操作指导视频.mp4",
      currentVideoName: "供应商入库-线上办理操作指导视频.mp4",
    };
  },
  computed: {
    strengthLabel() {
      if (!this.form.password) return "";
      const labels = ["", "弱", "弱", "中", "强"];
      return this.strengthScore > 0 ? `密码强度：${labels[this.strengthScore]}` : "";
    },
    strengthColor() {
      const colors = ["", "#e05a5a", "#e05a5a", "#e0a030", "#2d7a4f"];
      return colors[this.strengthScore] || "#aaa";
    },
  },
  watch: {
    modelValue(val) {
      if (val) {
        document.body.style.overflow = "hidden";
        this.$nextTick(() => {
          const input = this.$refs.usernameInput;
          if (input && typeof input.focus === "function") input.focus();
        });
      } else {
        document.body.style.overflow = "";
        this.reset();
      }
    },
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    close() {
      this.$emit("update:modelValue", false);
    },
    reset() {
      this.loading = false;
      this.success = false;
      this.showPassword = false;
      this.showConfirmPassword = false;
      this.strengthScore = 0;
      this.form = {
        username: "",
        password: "",
        confirmPassword: "",
      };
      this.errors = {
        username: "",
        password: "",
        confirmPassword: "",
      };
    },
    onKeydown(e) {
      if (e && e.key === "Escape" && this.modelValue) {
        this.close();
      }
    },
    onUsernameInput() {
      this.form.username = (this.form.username || "").replace(/\D/g, "").slice(0, 11);
      this.clearError("username");
    },
    onPasswordInput() {
      this.clearError("password");
      this.checkStrength();
    },
    clearError(field) {
      if (this.errors[field]) this.errors[field] = "";
    },
    showError(field, msg) {
      this.errors[field] = msg;
      this.$nextTick(() => {
        const elMap = {
          username: "supplier-username",
          password: "supplier-password",
          confirmPassword: "supplier-confirm-password",
        };
        const el = document.getElementById(elMap[field]);
        if (el && typeof el.focus === "function") el.focus();
      });
    },
    checkStrength() {
      const pwd = this.form.password || "";
      if (!pwd) {
        this.strengthScore = 0;
        return;
      }
      let score = 0;
      if (pwd.length >= 8) score++;
      if (/[A-Z]/.test(pwd)) score++;
      if (/[0-9]/.test(pwd)) score++;
      if (/[^A-Za-z0-9]/.test(pwd)) score++;
      this.strengthScore = score;
    },
    strengthSegmentClass(i) {
      const score = this.strengthScore;
      if (!score || i > score) return "";
      if (score <= 2) return "weak";
      if (score === 3) return "medium";
      return "strong";
    },
    submit() {
      if (this.loading) return;

      const username = (this.form.username || "").trim();
      // const password = this.form.password || "";
      // const confirmPassword = this.form.confirmPassword || "";

      if (!username) {
        this.showError("username", "请输入手机号");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(username)) {
        this.showError("username", "请输入正确的手机号");
        return;
      }
      // if (!password) {
      //   this.showError("password", "请输入密码");
      //   return;
      // }
      // if (password.length < 8) {
      //   this.showError("password", "密码至少需要8位字符");
      //   return;
      // }
      // if (!confirmPassword) {
      //   this.showError("confirmPassword", "请确认密码");
      //   return;
      // }
      // if (password !== confirmPassword) {
      //   this.showError("confirmPassword", "两次输入的密码不一致，请重新确认");
      //   return;
      // }

      this.form.username = username;
      this.loading = true;

      registerSupplier({ username })
        .then((res) => {
          const isOk = res && (res.success === true || res.code === 200 || res.code === 0);
          if (!isOk) {
            const msg = (res && (res.msg || res.message)) || "入库申请失败，请稍后重试";
            if (/手机号|账号|用户|用户名|已存在/.test(msg)) {
              this.showError("username", msg);
            } else {
              ElMessage({ message: msg, type: "error" });
            }
            return;
          }

          this.success = true;
          ElMessage({ message: "入库申请成功", type: "success" });
        })
        .catch((error) => {
          const msg =
            (error && (error.message || error.msg)) || "入库申请失败，请稍后重试";
          ElMessage({ message: msg, type: "error" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goLogin() {
      this.close();
      const base = process.env.VUE_APP_SUPPLiER_BASE_URL;
      const url = `${base}/login`;
      window.open(url, "_blank");
    },
    // 打开视频预览
    openVideoPreview() {
      this.videoPreviewVisible = true;
      document.body.style.overflow = "hidden";
    },
    // 关闭视频预览
    closeVideoPreview() {
      this.videoPreviewVisible = false;
      document.body.style.overflow = "";
    },
    // 下载视频
    downloadVideo() {
      try {
        const link = document.createElement("a");
        link.href = this.currentVideoUrl;
        link.download = this.currentVideoName;
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);
        ElMessage({ message: "开始下载视频", type: "success" });
      } catch (error) {
        console.error("下载视频失败:", error);
        ElMessage({ message: "下载失败，请稍后重试", type: "error" });
      }
    },
    // 视频加载开始事件
    handleVideoLoadStart() {
      console.log("视频开始加载");
    },
    // 视频元数据加载完成事件
    handleVideoLoadedMetadata() {
      console.log("视频元数据加载完成");
    },
    // 视频加载错误事件
    handleVideoError(event) {
      console.error("视频加载失败:", event);
      ElMessage({ message: "视频加载失败，请检查网络连接", type: "error" });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  --gold: #c8a45a;
  --gold-light: #e2c27d;
  --gold-dark: #a07830;
  --navy: #1a2540;
  --navy-light: #243052;
  --text-dark: #1c1c1e;
  --text-muted: #6b6b6e;
  --border: #e0d6c4;
  --success-green: #2d7a4f;
  --shadow-gold: rgba(200, 164, 90, 0.25);

  &,
  * {
    box-sizing: border-box;
  }

  position: fixed;
  inset: 0;
  background: rgba(15, 20, 35, 0.72);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.4s ease;
  padding: 20px;
}

.modal-overlay.active {
  opacity: 1;
  pointer-events: all;
}

.register-modal {
  background: #fff;
  width: 100%;
  max-width: 480px;
  position: relative;
  transform: translateY(30px) scale(0.97);
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28),
    0 0 0 1px rgba(200, 164, 90, 0.15);
}

.modal-overlay.active .register-modal {
  transform: translateY(0) scale(1);
}

.modal-top-bar {
  height: 4px;
  background: linear-gradient(
    90deg,
    var(--gold-dark),
    var(--gold-light),
    var(--gold-dark)
  );
}

.modal-header {
  padding: 32px 40px 24px;
  background: linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%);
  position: relative;
  overflow: hidden;
}

.modal-header::before {
  content: "";
  position: absolute;
  top: -40px;
  right: -40px;
  width: 120px;
  height: 120px;
  border: 1px solid rgba(200, 164, 90, 0.12);
  border-radius: 50%;
}

.modal-header::after {
  content: "";
  position: absolute;
  top: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  border: 1px solid rgba(200, 164, 90, 0.18);
  border-radius: 50%;
}

.modal-header-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.logo-emblem {
  width: 36px;
  height: 36px;
  border: 1.5px solid var(--gold);
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(45deg);
  flex-shrink: 0;
}

.logo-emblem-inner {
  width: 16px;
  height: 16px;
  background: var(--gold);
  transform: rotate(0deg);
}

.logo-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  letter-spacing: 1px;
  line-height: 1.5;
}

.modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
  margin-bottom: 6px;
}

.modal-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
  z-index: 10;
}

.modal-close:hover {
  border-color: var(--gold);
  color: var(--gold);
  background: rgba(200, 164, 90, 0.1);
}

.modal-body {
  padding: 32px 40px 36px;
}

.notice-bar {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background: linear-gradient(135deg, #fdf8ee, #fef9f0);
  border-left: 3px solid var(--gold);
  margin-bottom: 28px;
}

.notice-icon {
  width: 16px;
  height: 16px;
  color: var(--gold-dark);
  flex-shrink: 0;
  margin-top: 1px;
}

.notice-text {
  font-size: 12.5px;
  color: #7a6030;
  line-height: 1.6;
  letter-spacing: 0.3px;
  text-align: left;
}

.notice-text strong {
  color: var(--gold-dark);
  font-weight: 600;
}

.form-group {
  margin-bottom: 20px;
  text-align: left;
}

.form-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--navy);
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.form-label .required {
  color: var(--gold-dark);
  margin-left: 2px;
}

.form-input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 12px 44px 12px 44px;
  border: 1.5px solid var(--border);
  background: #fafaf8;
  font-size: 14px;
  color: var(--text-dark);
  outline: none;
  transition: all 0.25s ease;
  letter-spacing: 0.3px;
  border-radius: 0;
  -webkit-appearance: none;
}

.form-input:focus {
  border-color: var(--gold);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(200, 164, 90, 0.1);
}

.form-input::placeholder {
  color: #b0aaa0;
  font-size: 13px;
}

.form-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: var(--text-muted);
  pointer-events: none;
  transition: color 0.25s ease;
}

.form-input:focus ~ .form-input-icon,
.form-input-wrapper:focus-within .form-input-icon {
  color: var(--gold-dark);
}

.form-input-icon svg {
  width: 16px;
  height: 16px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-muted);
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.password-toggle:hover {
  color: var(--gold-dark);
}

.password-toggle svg {
  width: 16px;
  height: 16px;
}

.strength-bar {
  display: flex;
  gap: 4px;
  margin-top: 8px;
}

.strength-segment {
  height: 3px;
  flex: 1;
  background: #e5dfd5;
  transition: background 0.3s ease;
}

.strength-segment.weak {
  background: #e05a5a;
}

.strength-segment.medium {
  background: #e0a030;
}

.strength-segment.strong {
  background: var(--success-green);
}

.strength-label {
  font-size: 11px;
  color: var(--text-muted);
  margin-top: 4px;
  text-align: right;
}

.form-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border), transparent);
  margin: 8px 0 20px;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
}

.form-actions__buttons {
  display: flex;
  gap: 12px;
}

.form-actions .submit-btn {
  flex: 1;
  margin-top: 0;
}

.submit-btn {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, var(--navy) 0%, var(--navy-light) 100%);
  color: var(--gold-light);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  margin-top: 8px;
}

.submit-btn--ghost {
  background: transparent;
  color: var(--text-muted);
  border: 1.5px solid var(--border);
  box-shadow: none;
}

.submit-btn--ghost::before {
  display: none;
}

.submit-btn--ghost:hover {
  border-color: var(--navy);
  color: var(--navy);
  box-shadow: none;
}

.submit-btn--ghost.loading .btn-text {
  display: inline;
}

.submit-btn::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--gold-dark), var(--gold));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.submit-btn:hover::before {
  opacity: 1;
}

.submit-btn:hover {
  color: var(--navy);
  box-shadow: 0 6px 24px var(--shadow-gold);
  transform: translateY(-1px);
}

.submit-btn .btn-inner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: supplierRegisterSpin 0.7s linear infinite;
  display: none;
}

.submit-btn.loading .spinner {
  display: block;
}

.submit-btn.loading .btn-text {
  display: none;
}

@keyframes supplierRegisterSpin {
  to {
    transform: rotate(360deg);
  }
}

.success-state {
  display: none;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px 0 8px;
  animation: supplierRegisterFadeInUp 0.5s ease forwards;
}

.success-state.show {
  display: flex;
}

@keyframes supplierRegisterFadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-icon-wrap {
  width: 72px;
  height: 72px;
  border: 2px solid var(--gold);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
  animation: supplierRegisterSuccessPulse 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)
    forwards;
}

@keyframes supplierRegisterSuccessPulse {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.success-icon-wrap::before {
  content: "";
  position: absolute;
  inset: -8px;
  border: 1px solid rgba(200, 164, 90, 0.25);
}

.success-checkmark {
  width: 32px;
  height: 32px;
  color: var(--gold);
}

.success-title {
  font-size: 20px;
  font-weight: 700;
  color: var(--navy);
  letter-spacing: 2px;
  margin-bottom: 10px;
}

.success-desc {
  font-size: 13px;
  color: var(--text-muted);
  line-height: 1.8;
  margin-bottom: 28px;
  max-width: 300px;
}

.success-actions {
  display: flex;
  gap: 12px;
  width: 100%;
}

.btn-login {
  flex: 1;
  padding: 13px;
  background: linear-gradient(135deg, var(--navy), var(--navy-light));
  color: var(--gold-light);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 3px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn-login::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, var(--gold-dark), var(--gold));
  opacity: 0;
  transition: opacity 0.3s ease;
}

.btn-login:hover::before {
  opacity: 1;
}

.btn-login:hover {
  color: var(--navy);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px var(--shadow-gold);
}

.btn-login span {
  position: relative;
  z-index: 1;
}

.btn-close-modal {
  padding: 13px 20px;
  background: transparent;
  color: var(--text-muted);
  font-size: 13px;
  letter-spacing: 1px;
  border: 1.5px solid var(--border);
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-close-modal:hover {
  border-color: var(--navy);
  color: var(--navy);
}

.field-error {
  font-size: 12px;
  color: #d14040;
  margin-top: 6px;
  display: none;
}

.field-error.show {
  display: block;
}

.form-input.error {
  border-color: #d14040;
  box-shadow: 0 0 0 3px rgba(209, 64, 64, 0.08);
}

/* 附件预览样式 */
.attachment-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 0;
}

.attachment-label {
  font-size: 13px;
  color: var(--text-muted);
}

.attachment-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--gold-dark);
  cursor: pointer;
  transition: color 0.2s ease;
}

.attachment-link:hover {
  color: var(--gold);
}

.video-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.attachment-name {
  text-decoration: underline;
}

/* 视频预览弹窗 */
.video-preview-overlay {
  position: fixed;
  width: 800px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.video-preview-dialog {
  background: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.video-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: var(--navy);
  color: #fff;
}

.video-preview-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--gold-light);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.video-preview-close {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.video-preview-close:hover {
  border-color: var(--gold);
  color: var(--gold);
  background: rgba(200, 164, 90, 0.1);
}

.video-preview-body {
  flex: 1;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.video-preview-body video {
  width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.video-preview-footer {
  padding: 16px 20px;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
}

.video-preview-download {
  padding: 10px 32px;
  background: linear-gradient(135deg, var(--navy), var(--navy-light));
  color: var(--gold-light);
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.video-preview-download:hover {
  background: linear-gradient(135deg, var(--gold-dark), var(--gold));
  color: var(--navy);
}

@media (max-width: 520px) {
  .register-modal {
    max-width: 100%;
  }
  .modal-header {
    padding: 24px 24px 20px;
  }
  .modal-body {
    padding: 24px 24px 28px;
  }
  .success-actions {
    flex-direction: column;
  }
  .form-actions__buttons {
    flex-direction: column;
  }
  .video-preview-dialog {
    width: 95%;
  }
}
</style>
